import client from '../client';

const USERS = {
  signIn(params) {
    return client.post(`/sessions`, { user: params }, { withCredentials: true })
  },
}

export default USERS;
